import loadable from '@loadable/component';

export const PhoneInputLoadable = loadable(() => import('./PhoneInput'), {
  resolveComponent: (module) => module.PhoneInput,
});
